export function xorString(string: string, key: string): string {
  const stringLength = string.length, keyLength = key.length;
  let result = '';
  for (let i = 0; i < stringLength; i++) {
    result += String.fromCharCode(string.charCodeAt(i) ^ key.charCodeAt(i % keyLength));
  }
  return result;
}